import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "carouselOuter" }
const _hoisted_2 = ["src"]

import 'vue3-carousel/dist/carousel.css';
    import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselLayout',
  setup(__props) {

    const carouselConfig = {
      height: 190,
      gap: 5,
      autoplay: 4000,
      wrapAround: true,
      pauseAutoplayOnHover: true,
      breakpointMode: 'carousel', 
      breakpoints: {
        // 300px and up
        300: {
          itemsToShow: 1.4,
          snapAlign: 'center',
        },
        // 400px and up
        600: {
          itemsToShow: 2.4,
          snapAlign: 'center',
        },
        // 500px and up
        900: {
          itemsToShow: 3.4,
          snapAlign: 'center',
        },
        // 800px and up
        1200: {
          itemsToShow: 4.4,
          snapAlign: 'center',
        },
          1450: {
          itemsToShow: 5.4,
          snapAlign: 'center',
        },
          1650: {
          itemsToShow: 6.4,
          snapAlign: 'center',
        }
      }
  }

    const images = Array.from({ length: 14 }, (_, index) => ({
        id: index + 1,
        url: require('../../assets/carousel/' + (index+1) + '.jpg'),
      }))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Carousel), _normalizeProps(_guardReactiveProps(carouselConfig)), {
      addons: _withCtx(() => [
        _createVNode(_unref(Navigation)),
        _createVNode(_unref(Pagination))
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (image) => {
          return (_openBlock(), _createBlock(_unref(Slide), {
            key: image.id
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: image.url,
                alt: "image"
              }, null, 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 16)
  ]))
}
}

})